if (!customElements.get('product-icon-text-tabs')) {
  customElements.define('product-icon-text-tabs', class extends HTMLElement {
    constructor() {
      super();
      // 使用事件委托，兼容主题编辑器重新插入区块。
      this.addEventListener('click', (event) => {
        const button = event.target.closest('.product-icon-text-tabs__label');
        if (!button || !this.contains(button)) return;

        const shouldExpand = button.getAttribute('aria-expanded') !== 'true';
        const panelId = button.getAttribute('aria-controls');

        // 再次点击当前标签时全部收起，否则仅展开选中项。
        this.querySelectorAll('.product-icon-text-tabs__label').forEach((label) => {
          label.setAttribute('aria-expanded', String(shouldExpand && label === button));
        });
        this.querySelectorAll('.product-icon-text-tabs__panel').forEach((panel) => {
          panel.hidden = !(shouldExpand && panel.id === panelId);
        });
      });
    }
  });
}
